<template>
  <div id="app">
    <Navbar @local-change="onChangeLocal" data-aos="fade-down"/>
    <router-view :reload="reload"></router-view>
    <Footer/>
  </div>
</template>

<script>
import Navbar from './components/components/Navbar.vue'
import Footer from './components/components/Footer.vue'

import AOS from 'aos';
import 'aos/dist/aos.css';

AOS.init();

export default {
  name: 'App',
  components: {
    Navbar,
    Footer
  },
  data() {
    return {              
      reload: false
    }
  },
  methods: {
    onChangeLocal(value) {
      console.log("App receive event lang : "+value)
      this.reload = true
    }
  }
}
</script>

<style src="./assets/reset.css"></style>
<style src="./assets/fonts.css"></style>
<style>
  /* app css */
  html {
    scroll-behavior: smooth;
  }
  #app {
    font-family: AvenirNext, Helvetica, Arial, sans-serif;
    background: url(./assets/header-oval-mobile.svg) no-repeat;
    background-size: 135% 500px;
    background-position: top center;
    color: #fff;
    overflow: hidden;
  }
  @media (min-width: 330px){
    #app {
      background-size: 135% 410px;
      background-position: top center;
    }
  }
  @media (min-width: 440px){
    #app {
      background-size: 230% 370px;
      background-position: top center;
    }
  }
  @media (min-width: 768px){
    #app {
       background: url(./assets/Header-Oval.svg) no-repeat;
      background-size: 100% 380px;
      background-position: top center;
    }
  }
  @media (min-width: 980px){
    #app {
      background-size: 250% 310px;
      background-position: top center;
    }
  }
  @media (min-width: 1200px){
    #app {
      background-size: 150% 620px;
      background-position: top center;
    }
  }

  a,
  a:hover {
    color: #fff !important;
    text-decoration: none !important;
  }

  .navbar-toggler-icon {
    display: none !important;
    color: transparent;
  }

  main>.container>section.fond h1 {
    margin: 30px 0;
    font-size: 32px;
    font-weight: bold;
    text-align: center;
  }
  main>.container>section.fond .content {
    background: rgba(255,255,255,0.85);
    color: #2459a0;
    padding: 20px;
    font-size: 18px;
  }
  main>.container>section.fond .content a,
  main>.container>section.fond .content a:hover {
    color: #2459a0 !important;
  }
  main>.container>section.fond .content p {
    margin-bottom: 30px;
    line-height: 1.5;
  }
  
  .offre .content ul {
    margin-bottom: 10px;

  }
  .offre .content li {
    list-style: inside !important;
    font-weight: bold;
    line-height: 18px;
  }
  
  /* desktop */
  @media (min-width: 992px){
    main>.container>section.fond h1 {
      margin: 80px 0;
    }
  }
  @media (min-width: 1200px){
    .navbar .navbar-collapse {   
      position: relative;
      margin-right: 80px;
    }

    main>.container>section.fond h1 {
      font-size: 46px;
      text-align: center;
      margin: 100px 0;
    }
  }
</style>
